import { Legs } from './legs';
import { ShaderNBox } from '../shaders/legs/shader_n_box';
import { ProductType } from '@/store/modules/product';
import { ShaderNOkragla } from '../shaders/legs/shader_n_okagla';
import { ShaderNPlozy } from '../shaders/legs/shader_n_plozy';
import { ShaderNStGiety } from '../shaders/legs/shader_n_st_giety';
import { ShaderNStBox } from '../shaders/legs/shader_n_st_box';
import { ShaderNStProsta } from '../shaders/legs/shader_n_st_prosta';
import { ShaderNStPrzesun } from '../shaders/legs/shader_n_st_przesun';
import { ShaderNStScieta } from '../shaders/legs/shader_n_st_scieta';
import { ShaderNStStozek } from '../shaders/legs/shader_n_st_stozek';
import { ShaderNStozek } from '../shaders/legs/shader_n_stozek';
import { ShaderNWalec } from '../shaders/legs/shader_n_walec';
import { ShaderNSlizgacz } from '../shaders/legs/shader_n_slizgacz';

export const bedsideTableLegs = [
    new Legs(
        `sn_n_slizgacz_455x455.gltf`,
        `sn_n_slizgacz_455x455_light.jpg`,
        new ShaderNSlizgacz(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_slizgacz_icon.jpg',
        20,
    ),
    new Legs(
        `sn_n_box_455x455.gltf`,
        `sn_n_box_455x455_light.jpg`,
        new ShaderNBox(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_noga_prosta_debowa_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_okragla_455x455.gltf`,
        `sn_n_okragla_455x455_light.jpg`,
        new ShaderNOkragla(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_noga_metalowa_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_plozy_455x455.gltf`,
        `sn_n_plozy_455x455_light.jpg`,
        new ShaderNPlozy(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_ploza_metalowa_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_st_box_455x455.gltf`,
        `sn_n_st_box_455x455_light.jpg`,
        new ShaderNStBox(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_stelaz_skosny_drewniany_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_st_giety_455x455.gltf`,
        `sn_n_st_giety_455x455_light.jpg`,
        new ShaderNStGiety(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_stelaz_giety_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_st_prosta_455x455.gltf`,
        `sn_n_st_prosta_455x455_light.jpg`,
        new ShaderNStProsta(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_stelaz_prosty_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_st_przesun_455x455.gltf`,
        `sn_n_st_przesun_455x455_light.jpg`,
        new ShaderNStPrzesun(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_stelaz_skosny_metalowy_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_st_scieta_455x455.gltf`,
        `sn_n_st_scieta_455x455_light.jpg`,
        new ShaderNStScieta(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_stelaz_skosny_debowy_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_st_stozek_455x455.gltf`,
        `sn_n_st_stozek_455x455_light.jpg`,
        new ShaderNStStozek(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_stelaz_skosny_drewniany_stozek_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_stozek_455x455.gltf`,
        `sn_n_stozek_455x455_light.jpg`,
        new ShaderNStozek(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_noga_stozek_drewniana_icon.jpg',
        200,
    ),
    new Legs(
        `sn_n_walec_455x455.gltf`,
        `sn_n_walec_455x455_light.jpg`,
        new ShaderNWalec(),
        0,
        ProductType.BEDSIDE_TABLE,
        'sn_noga_walec_debowa_icon.jpg',
        200,
    ),
];
